import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
  import MdaeDataGrid, {
    IMdaeDataGridProps,
  } from "../../../../common_components/common_widgets/data-grid";
import { isEmpty, isEqual } from "lodash";
import "./index.scss";
import MdaeButton from "../../../../common_components/common_widgets/button";
import { MasterDetail } from "devextreme-react/data-grid";
import { GET_REMIT_DETAIL } from "./services/get-remit-detail";
import { convertDate } from "../../../../utils/dateUtils";
import { ADD_SELECTED_IDS_FROM_CASE_PAY_LINES, expandcollapseTitles, getNumber, getRemitSelectionListProperty, SET_EXPAND_COLLAPSE_BUTTON_TITLE, SET_REMIT_DETAIL_DATA, TOGGLE_REMIT_DETAIL_POPUP } from "./reducers/remit-detail-reducer";
import $ from "jquery";
import { Selection } from "devextreme-react/data-grid";
import { toggleBillHistoryPopupVisible } from "../bill-history";
import { SAVE_SELECTED_CASE_PAY_LINES } from "./services/save-selected-case-pay-lines";
import { actions } from "async-ops";
import { SET_CASE_FORM_DATA } from "../../case-detail/case-data/reducers/case-data-reducer";
import Guid from "devextreme/core/guid";
import { TOGGLE_CONFIRMATION_POPUP } from "../../../../common_components/mdae-common-reducer";
import MdaeCheckBox from "../../../../common_components/common_widgets/check-box";

export const assignAtRiskAmntForLine = (selectedCodes, roundCharges, claimRemitType = 'REMIT') => {
  if (!Array.isArray(selectedCodes)) return [];
  if (!Array.isArray(roundCharges)) roundCharges = [];

  const importedMap = new Map();
  roundCharges.forEach((item) => {
    importedMap.set(`${item.targetId}|${item.targetType}`, item.atRiskAmnt);
  });

  const importedTargetIds = new Set(roundCharges.map((item) => item.targetId));

  const grouped = {};
  selectedCodes.forEach((item) => {
    if (!grouped[item.targetId]) grouped[item.targetId] = [];
    grouped[item.targetId].push(item);
  });

  return selectedCodes.map((item) => {
      if (item.type !== claimRemitType) {
      return { ...item, atRiskAmnt: item.atRiskAmnt, reviewRemainingAmnt: item.atRiskAmnt };
    }
    const key = `${item.targetId}|${item.targetType}`;
    // 1. If this (targetId, targetType) exists in roundCharges, use its atRiskAmnt
    if (importedMap.has(key)) {
      return { ...item, atRiskAmnt: importedMap.get(key), reviewRemainingAmnt: importedMap.get(key) };
    }
    // 2. If this targetId exists in roundCharges but not this type, set atRiskAmnt to 0
    if (importedTargetIds.has(item.targetId)) {
      return { ...item, atRiskAmnt: 0, reviewRemainingAmnt: 0 };
    }
    // 3. If both CPTHCPCS and MODIFIER exist for this targetId in selectedCodes, prefer CPTHCPCS
    const group = grouped[item.targetId];
    if (
      group.some((i) => i.targetType === "CPTHCPCS") &&
      item.targetType === "MODIFIER"
    ) {
      return { ...item, atRiskAmnt: 0, reviewRemainingAmnt: 0 };
    }
    // 4. Otherwise, keep as is
    return { ...item, atRiskAmnt: item.atRiskAmnt, reviewRemainingAmnt: item.atRiskAmnt };
  });
};

const RemitFields : React.FC<any> = () => {
const dispatch = useDispatch();
const [lineLevelAdjustmentDataGridInstance, setLineLevelAdjustmentDataGridInstance] = useState(null);
const onLineLevelAdjustmentDataGridInitialized = (e) => {
    setLineLevelAdjustmentDataGridInstance(e.component);
  };
const remitData = useSelector(
    (state) => state["remitDetailReducer"].remitData,
    isEqual
);
const caseDetailId = useSelector(
    (state) => state["remitDetailReducer"].caseDetailId,
    isEqual
);
const expandcollaplseButtonTitle = useSelector(
    (state) => state["remitDetailReducer"].expandcollaplseButtonTitle,
    isEqual
);

const varToUpdate = useSelector(
  (state) => state["remitDetailReducer"].varToUpdate,
  isEqual
);
const selectedSelectionListProperty = getRemitSelectionListProperty(varToUpdate);

const remitFieldsData = useSelector(
    (state) =>
      state["remitDetailReducer"],
    isEqual
);
const totalAmount = useSelector(
  (state) =>
    state["remitDetailReducer"].totalPaidAmount,
  isEqual
);
const caseData = useSelector(
  (state) => state["billHistoryReducer"].caseData,
  isEqual
);
  const caseDetailData = useSelector(
    (state) => state["caseDataReducer"].caseData
  );
  const currentImportRoundData = useSelector(
    (state) => state["caseDataReducer"].currentImportRoundData
  );
  const isVisibleFromImportCharges = useSelector(
    (state) => state["billHistoryReducer"].isVisibleFromImportCharges
  );
  const [selectedCodes, setSelectedCodes] = useState([]);

  const selectedCodesRef = useRef([]);

  useEffect(() => {
    selectedCodesRef.current = selectedCodes;
  }, [selectedCodes]);

  const getAllRoundCharges = useCallback(() => {
    const tempRoundCharges = [];
    if (Array.isArray(caseDetailData?.roundData)) {
      caseDetailData.roundData.forEach((round) => {
        if (Array.isArray(round.roundCharges)) {
          tempRoundCharges.push(...round.roundCharges);
        }
      });
    }
    return tempRoundCharges;
  }, [caseDetailData]);

    useEffect(() => {
      if (
        remitData?.linelevelAdjustmentList &&
        remitData.linelevelAdjustmentList.length > 0
      ) {
        const allRoundCharges = getAllRoundCharges();
        let list = [];
        if (allRoundCharges.length > 0 && caseDetailId > 0) {
          list = allRoundCharges
            ?.filter(
              (rc) =>
                rc.claimRemitType === "REMIT" &&
                rc.billingCaseDetailId === caseDetailId
            )
            .map((rc) => ({
              codeValue: rc.roundTargetValue,
              targetType: rc.roundTargetType,
              caseDetailId: rc.billingCaseDetailId,
              type: rc.claimRemitType,
              revenueCode: rc.revenueCode,
              targetId: rc.targetId,
              atRiskAmnt: rc.atRiskAmnt,
            }));
        }
        remitData.linelevelAdjustmentList.forEach((adj) => {
          if (
            remitFieldsData &&
            remitFieldsData?.selectedKeys &&
            remitFieldsData?.selectedKeys.includes(adj.casePayLineId) &&
            !list.some((item) => item.targetId === adj.casePayLineId)
          ) {
            list.push({
              codeValue: adj.hcpcsCode,
              targetType: "CPTHCPCS",
              caseDetailId: caseDetailId,
              type: "REMIT",
              revenueCode: adj.revCode,
              targetId: adj.casePayLineId,
              atRiskAmnt: getNumber(adj.providerPayment),
            });
          }
        });
        setSelectedCodes(list);
      }
    }, [remitData?.linelevelAdjustmentList, caseDetailId]);

    const handleApplyRemitFields = useCallback(() => {
      dispatch(
        actions.asyncOperationStart(SAVE_SELECTED_CASE_PAY_LINES, {
          caseDetailId: caseDetailId,
          [selectedSelectionListProperty]: remitFieldsData.selectedKeys,
          [`${selectedSelectionListProperty}Amount`]: totalAmount,
          eaCaseId: caseData.eaCaseId,
        })
      );
      dispatch({
        type: SET_CASE_FORM_DATA,
        data: {
          caseData: { [`${varToUpdate}Amnt`]: totalAmount },
        },
      });
      dispatch({
        type: SET_REMIT_DETAIL_DATA,
        data: {
          selectedKeys: [],
          totalAmount: 0,
        },
      });
      toggleBillHistoryPopupVisible(dispatch, false, null, false);

      if (isVisibleFromImportCharges) {
        dispatch({
          type: TOGGLE_REMIT_DETAIL_POPUP,
          data: { isRemitDetailPopupVisible: false },
        });

        if (caseDetailData?.roundData) {
          const currentRound = caseDetailData.roundData.find(
            (round) =>
              round.eaRoundCaseId === currentImportRoundData.eaRoundCaseId
          );
          let roundCharges = currentRound
            ? currentRound.roundCharges || []
            : [];

          let unSavedSelectedTypeList = assignAtRiskAmntForLine(
            selectedCodes,
            roundCharges
          );

          //  1. Identify NEW objects to ADD

          const newObjs = unSavedSelectedTypeList
            .filter(
              (obj) =>
                !roundCharges.some(
                  (item) =>
                    item.roundTargetType === obj.targetType &&
                    item.roundTargetValue === obj.codeValue &&
                    item.billingCaseDetailId === obj.caseDetailId &&
                    item.claimRemitType === obj.type &&
                    item.targetId === obj.targetId
                )
            )
            .map((obj) => ({
              ...obj,
              roundTargetType: obj.targetType,
              roundTargetValue: obj.codeValue,
              eaRoundCaseLineLevelTrackingIdString: new Guid().toString(),
              billingCaseDetailId: obj.caseDetailId,
              claimRemitType: obj.type,
            }));

          //  3. Update roundData → remove unchecked, add new checked
          const updatedRoundData = caseDetailData.roundData.map((round) => {
            if (round.eaRoundCaseId === currentImportRoundData.eaRoundCaseId) {
              const filteredCharges = round.roundCharges.filter((charge) => {
                // Keep if not REMIT, or if present in unSavedSelectedTypeList
                if (charge.claimRemitType !== "REMIT") return true;
                // Remove REMIT charges whose billingCaseDetailId does not match caseDetailId
                if (
                  charge.claimRemitType === "REMIT" &&
                  charge.billingCaseDetailId !== caseDetailId
                ) {
                  return false;
                }
                return unSavedSelectedTypeList.some(
                  (r) =>
                    r.targetType === charge.roundTargetType &&
                    r.codeValue === charge.roundTargetValue &&
                    r.caseDetailId === charge.billingCaseDetailId &&
                    r.targetId === charge.targetId
                );
              });
              return {
                ...round,
                roundCharges: [...filteredCharges, ...newObjs],
              };
            }
            return round;
          });
          // Get sum of atRiskAmnt for unique targetIds from updatedRoundData for current caseDetailId
          const allUpdatedCharges = updatedRoundData
            .flatMap((round) => round.roundCharges || [])
            .filter((charge) => charge.billingCaseDetailId === caseDetailId);

          const uniqueChargesMap = new Map();
          allUpdatedCharges.forEach((charge) => {
            if (!uniqueChargesMap.has(charge.targetId)) {
              uniqueChargesMap.set(charge.targetId, charge);
            }
          });

          const sumUniqueAtRiskAmnt = Array.from(
            uniqueChargesMap.values()
          ).reduce((sum, charge) => sum + Number(charge.atRiskAmnt || 0), 0);

          dispatch({
            type: SET_CASE_FORM_DATA,
            data: {
              caseData: {
                ...caseDetailData,
                [`${varToUpdate}Amnt`]: sumUniqueAtRiskAmnt,
                roundData: updatedRoundData,
              },
            },
          });
        }
      }
    }, [
      dispatch,
      actions,
      caseDetailId,
      selectedSelectionListProperty,
      remitFieldsData.selectedKeys,
      totalAmount,
      caseData.eaCaseId,
      varToUpdate,
      isVisibleFromImportCharges,
      selectedCodes,
      caseDetailData,
      currentImportRoundData,
    ]);

  const hideConfirmationPopup = () => {
    dispatch({
      type: TOGGLE_CONFIRMATION_POPUP,
      data: {
        visible: false,
      },
    });
  };
  const showConfirmationPopup = () => {
    dispatch({
      type: TOGGLE_CONFIRMATION_POPUP,
      data: {
        onConfirm: () => {
          handleApplyRemitFields();
          hideConfirmationPopup();
        },
        visible: true,
        confirmShown: true,
        declineShown: true,
        cancelShown: false,
        width: 380,
        height: 200,
        contentHtml: `This line is currently being tracked via Round. These changes will delete any target types being tracked. Do you wish to proceed?`,
        title: "Warning",
        confirmLabel: "OK",
        declineLabel: "Cancel",
        onDecline: () => hideConfirmationPopup(),
      },
    });
  };

  const getSelectedRowKeys = useCallback(() => {
    return selectedCodes.map((c) => c.targetId);
  }, [selectedCodes]);

  const isCodeSelected = (casePayLineId, codeValue, type) => {
    return selectedCodesRef.current.some(
      (c) =>
        c.targetId === casePayLineId &&
        c.codeValue === codeValue &&
        c.targetType === type
    );
  };

  const completeCaseDetail = useSelector(
    (state) => state["caseDetailReducer"].completeCaseDetail,
    isEqual
  );

  const remitDrgTargetType = completeCaseDetail?.isAPRDRG ? "APR_DRG" : "DRG";

  const isDrgSelected = useMemo(() => {
    return selectedCodes.some(
      (c) => (c.targetType === 'DRG' || c.targetType === 'APR_DRG') && c.codeValue === remitData.drg
    );
  }, [selectedCodes, remitData.drg]);

  const onRemitDrgCheckboxChanged = useCallback((e) => {
    if (!remitData.drg) return;
    setSelectedCodes((prev) => {
      if (e.value) {
        const exists = prev.some(
          (c) => (c.targetType === 'DRG' || c.targetType === 'APR_DRG') && c.codeValue === remitData.drg
        );
        if (!exists) {
          return [
            ...prev,
            {
              targetId: 0,
              codeValue: remitData.drg,
              targetType: remitDrgTargetType,
              atRiskAmnt: 0,
              revenueCode: '',
              caseDetailId: caseDetailId,
              type: 'REMIT',
            },
          ];
        }
        return prev;
      } else {
        return prev.filter(
          (c) => !((c.targetType === 'DRG' || c.targetType === 'APR_DRG') && c.codeValue === remitData.drg)
        );
      }
    });
  }, [remitData.drg, remitDrgTargetType, caseDetailId]);

const claimLevelAdjustmentDataGridOptions = useMemo(() => {
    return getClaimLevelAdjustmentDataGridOptions(
        remitData
    );
}, [remitData]);

const claimLevelRemarksDataGridOptions = useMemo(() => {
    return getClaimLevelRemarksDataGridOptions(
        remitData
        );
},[remitData]);

const onLineLevelAdjustmentGridCellClick = useCallback(
  (e) => {
    if (isVisibleFromImportCharges) {
      if (e.rowType !== "data") return;
      const row = e.data;
      const gridInstance = e.component;

      if (e.column.dataField === "hcpcs") {
        setSelectedCodes((prev) => {
          const exists = prev.some(
            (c) =>
              c.targetId === row.casePayLineId &&
              c.codeValue === row.hcpcsCode &&
              c.targetType === "CPTHCPCS"
          );
          if (!exists) {
            return [
              ...prev,
              {
                targetId: row.casePayLineId,
                codeValue: row.hcpcsCode,
                targetType: "CPTHCPCS",
                atRiskAmnt: getNumber(row.providerPayment),
                revenueCode: row.revCode,
                caseDetailId: caseDetailId,
                type: "REMIT",
              },
            ];
          } else {
            return prev.filter(
              (c) =>
                !(
                  c.targetId === row.casePayLineId &&
                  c.codeValue === row.hcpcsCode &&
                  c.targetType === "CPTHCPCS"
                )
            );
          }
        });
        gridInstance.refresh();
      }
      if (e.column.dataField === "modifiers" && row.modifiers) {
        setSelectedCodes((prev) => {
          const exists = prev.some(
            (c) =>
              c.targetId === row.casePayLineId &&
              c.codeValue === row.modifiers &&
              c.targetType === "MODIFIER"
          );
          if (!exists) {
            return [
              ...prev,
              {
                targetId: row.casePayLineId,
                codeValue: row.modifiers,
                targetType: "MODIFIER",
                atRiskAmnt: getNumber(row.providerPayment),
                revenueCode: row.revCode,
                caseDetailId: caseDetailId,
                type: "REMIT",
              },
            ];
          } else {
            return prev.filter(
              (c) =>
                !(
                  c.targetId === row.casePayLineId &&
                  c.codeValue === row.modifiers &&
                  c.targetType === "MODIFIER"
                )
            );
          }
        });
        gridInstance.refresh();
      }
    }
  },
  [caseDetailId, isVisibleFromImportCharges]
);

const onLineLevelAdjustmentGridCellPrepared = useCallback(
  (e) => {
    if (e.rowType === "data" && e.column.command === "expand") {
      if (e.data.state == "Billed") {
        $(e.cellElement).removeClass("dx-datagrid-expand");
        $(e.cellElement).empty();
      } else if (e.data.state == "Paid") {
      }
    }

    if (isVisibleFromImportCharges) {
      if (e.rowType === "data" && e.column.dataField === "hcpcs") {
        const found = isCodeSelected(
          e.data.casePayLineId,
          e.data.hcpcsCode,
          "CPTHCPCS"
        );
        e.cellElement.style.backgroundColor = found ? "#15e846ff" : "";
      }
      if (
        e.rowType === "data" &&
        e.column.dataField === "modifiers" &&
        e.data.modifiers
      ) {
        const found = isCodeSelected(
          e.data.casePayLineId,
          e.data.modifiers,
          "MODIFIER"
        );
        e.cellElement.style.backgroundColor = found ? "#15e846ff" : "";
      }
    }
  },
  [isCodeSelected, selectedCodes, isVisibleFromImportCharges]
);


const lineLevelAdjustmentDataGridOptions = useMemo (() => {
    return getLineLevelAdjustmentDataGridOptions(
        onLineLevelAdjustmentDataGridInitialized,
        onLineLevelAdjustmentGridCellPrepared,
        remitData,
        onLineLevelAdjustmentGridCellClick
    )
},[remitData,onLineLevelAdjustmentGridCellClick]);

const expandCollapseAllAdjustments = () => {
    let updateExpandCollaplseBtnTitle = "";
    if (expandcollaplseButtonTitle == 'Expand All') {
        lineLevelAdjustmentDataGridInstance.expandAll(-1);
        updateExpandCollaplseBtnTitle = expandcollapseTitles.COLLAPSE_ALL;
    }
    else {
        lineLevelAdjustmentDataGridInstance.collapseAll(-1);
        updateExpandCollaplseBtnTitle = expandcollapseTitles.EXPAND_ALL;
    }
    dispatch({
     type: SET_EXPAND_COLLAPSE_BUTTON_TITLE,
     data: {
        expandcollaplseButtonTitle: updateExpandCollaplseBtnTitle
     }
    });
}
const onSelectionChanged = useCallback(
  (e) => {
      dispatch({
        type: ADD_SELECTED_IDS_FROM_CASE_PAY_LINES,
        data: {
          selectedKeys: e.selectedRowKeys,
          selectedRows: e.selectedRowsData,
        },
      });
    if (isVisibleFromImportCharges) {
      const newSelectedCodes = [...selectedCodes];
      e.selectedRowsData.forEach((row) => {
        const exists = newSelectedCodes.some(
          (c) =>
            c.targetId === row.casePayLineId &&
            c.codeValue === row.hcpcsCode &&
            c.targetType === "CPTHCPCS"
        );
        if (!exists) {
          newSelectedCodes.push({
            targetId: row.casePayLineId,
            codeValue: row.hcpcsCode,
            targetType: "CPTHCPCS",
            atRiskAmnt: getNumber(row.providerPayment),
            revenueCode: row.revCode,
            caseDetailId: caseDetailId,
            type: "REMIT",
          });
        }
      });
      const gridInstance = e.component;
      const selectedIds = e.selectedRowKeys;
      const filtered = newSelectedCodes.filter((code) => {
        if (code.targetType === "CPTHCPCS") {
          return selectedIds.includes(code.targetId);
        }
        return true;
      });
      setSelectedCodes(filtered);
      gridInstance.refresh();
    }
  },
  [isVisibleFromImportCharges, selectedCodes, caseDetailId, dispatch]
);

const LineLevelAdjustmentDetail : React.FC<any> = (props) => {

const lineLevelAdjustReasonDataGridOptions = useMemo (() => {
    return getLineLevelAdjustReasonDataGridOptions(
        props.data.data?.lineLevelAdjustReasonList
    )
},[props.data.data?.lineLevelAdjustReasonList]);

const lineLevelRemarksCodeDataGridOptions = useMemo (() => {
    return getLineLevelRemarksCodeDataGridOptions(
        props.data.data?.lineLevelRemarksCodeList
    )
},[props.data.data?.lineLevelRemarksCodeList]);

    return (
      <div>
        <div>
          <MdaeDataGrid
            {...lineLevelAdjustReasonDataGridOptions}
          ></MdaeDataGrid>
        </div>
        <div style={{ marginTop: "15px" }}>
          <MdaeDataGrid {...lineLevelRemarksCodeDataGridOptions}
          >
          </MdaeDataGrid>
        </div>
      </div>
    );
}

const renderAdjustmentsGridToolbarButtonTemplate = () => {
    return(
        <div style={{display: "flex"}}>
        <MdaeButton
        id="btnExpandCollapseAllAdjustments"
        role="secondary"
        icon={expandcollaplseButtonTitle === expandcollapseTitles.EXPAND_ALL ? "fa fa-plus application-section-primary-color" : "fa fa-minus application-section-primary-color"}
        text={expandcollaplseButtonTitle}
        elementAttr={{
          id: "expandCollapseAllAdjustmentsIcon",
          title: expandcollaplseButtonTitle,
        }}
        stylingMode= "text"
        onClick={() =>{
            expandCollapseAllAdjustments();
        }}
        >
        </MdaeButton>
    </div>
    )
}
return (
  <div style={{ marginTop: "15px" }} className="remit-fields">
    <div style={{ display: "flex" }}>
      <div className="remit-fields-detail-container1">
        <div className="remit-fields-container-border">
          <div className="remit-fields-header-container">
            <span className="mdae-data-field-label">Patient</span>
          </div>
          <div className="remit-fields-sub-header-container">
            <div className="field-detail-container">
              <div className="sub-header-field-label">
                <span className="mdae-data-field-label">Name :</span>
              </div>
              <div
                className="mdae-data-field-content text-overflow-ellipsis"
                style={{ width: "unset" }}
                title={remitData.patientName}
              >
                {remitData.patientName}
              </div>
            </div>
            <div className="field-detail-container">
              <div className="sub-header-field-label">
                <span className="mdae-data-field-label">ID :</span>
              </div>
              <div className="mdae-data-field-content">
                {remitData.patientIdCode}
              </div>
            </div>
            <div className="field-detail-container">
              <div className="sub-header-field-label">
                <span className="mdae-data-field-label">Account # :</span>
              </div>
              <div className="mdae-data-field-content">
                {remitData.patientAcctNoOrig}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="remit-fields-detail-container1"
        style={{ paddingLeft: "15px" }}
      >
        <div className="remit-fields-container-border">
          <div className="remit-fields-header-container">
            <span className="mdae-data-field-label">Subscriber</span>
          </div>
          <div className="remit-fields-sub-header-container">
            <div className="field-detail-container">
              <div className="sub-header-field-label">
                <span className="mdae-data-field-label">Name :</span>
              </div>
              <div
                className="mdae-data-field-content text-overflow-ellipsis"
                style={{ width: "unset" }}
                title={remitData.subscriberName}
              >
                {remitData.subscriberName}
              </div>
            </div>
            <div className="field-detail-container">
              <div className="sub-header-field-label">
                <span className="mdae-data-field-label">ID :</span>
              </div>
              <div className="mdae-data-field-content">
                {remitData.subscriberIdCode}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="remit-fields-detail-container1"
        style={{ paddingLeft: "15px" }}
      >
        <div className="remit-fields-container-border">
          <div className="remit-fields-header-container">
            <span className="mdae-data-field-label">Bill Type</span>
          </div>
          <div className="remit-fields-sub-header-container">
            <div className="field-detail-container">
              <div className="sub-header-field-label">
                <span className="mdae-data-field-label">Facility :</span>
              </div>
              <div
                className="mdae-data-field-content text-overflow-ellipsis"
                style={{ width: "unset" }}
                title={remitData.facilityCode}
              >
                {remitData.facilityCode}
              </div>
            </div>
            <div className="field-detail-container">
              <div className="sub-header-field-label">
                <span className="mdae-data-field-label">Frequency :</span>
              </div>
              <div
                className="mdae-data-field-content text-overflow-ellipsis"
                style={{ width: "unset" }}
                title={remitData.frequencyDescription}
              >
                {remitData.frequencyDescription}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="remit-fields-detail-container1"
        style={{ paddingLeft: "15px" }}
      >
        <div className="remit-fields-container-border">
          <div className="remit-fields-header-container">
            <span className="mdae-data-field-label">Payer</span>
          </div>
          <div className="remit-fields-sub-header-container">
            <div className="field-detail-container">
              <div className="sub-header-field-label">
                <span className="mdae-data-field-label">Name :</span>
              </div>
              <div
                className="mdae-data-field-content text-overflow-ellipsis"
                style={{ width: "unset" }}
                title={remitData.payerName}
              >
                {remitData.payerName}
              </div>
            </div>
            <div className="field-detail-container">
              <div className="sub-header-field-label">
                <span className="mdae-data-field-label">Type :</span>
              </div>
              <div className="mdae-data-field-content">
                {remitData.payerType}
              </div>
            </div>
            <div className="field-detail-container">
              <div className="sub-header-field-label">
                <span className="mdae-data-field-label">Remit Date :</span>
              </div>
              <div className="mdae-data-field-content">
                {convertDate(remitData.remitDateString)}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style={{ display: "flex", marginTop: "15px" }}>
      <div className="remit-fields-detail-container2">
        <div className="field-detail-container">
          <div className="sub-header-field-label">
            <span className="mdae-data-field-label">Claim Status :</span>
          </div>
          <div className="mdae-data-field-content">
            {remitData.claimStatusCode} {remitData.claimStatusDescription}
          </div>
        </div>
        <div className="field-detail-container">
          <div className="sub-header-field-label">
            <span className="mdae-data-field-label">Statement Dates : </span>
          </div>
          <div className="mdae-data-field-content">
            {convertDate(remitData.statementFromDateString)} -{" "}
            {convertDate(remitData.statementToDateString)}
          </div>
        </div>
        <div className="field-detail-container">
          {isVisibleFromImportCharges && remitData.drg && (
            <div style={{ marginRight: '8px', flexShrink: 0 }}>
              <MdaeCheckBox
                id="chkRemitDrg"
                value={isDrgSelected}
                onValueChanged={onRemitDrgCheckboxChanged}
              />
            </div>
          )}
          <div className="sub-header-field-label" style={isVisibleFromImportCharges && remitData.drg ? { width: 'calc(30% - 26px)' } : undefined}>
            <span className="mdae-data-field-label">DRG : </span>
          </div>
          <div className="mdae-data-field-content">{remitData.drg}</div>
        </div>
        <div className="field-detail-container">
          <div className="sub-header-field-label">
            <span className="mdae-data-field-label">DRG Weight : </span>
          </div>
          <div className="mdae-data-field-content">{remitData.drgWeight}</div>
        </div>
        <div className="field-detail-container">
          <div className="sub-header-field-label">
            <span className="mdae-data-field-label">Discharge Fraction : </span>
          </div>
          <div className="mdae-data-field-content">
            {remitData.dischargeFraction}
          </div>
        </div>
      </div>
      <div className="remit-fields-detail-container2">
        <div className="field-detail-container">
          <div className="sub-header-field-label">
            <span className="mdae-data-field-label">Total Charges : </span>
          </div>
          <div className="mdae-data-field-content">
            {remitData.totalClaimChargeAmt}
          </div>
        </div>
        <div className="field-detail-container">
          <div className="sub-header-field-label">
            <span className="mdae-data-field-label">Payment Amount : </span>
          </div>
          <div className="mdae-data-field-content">{remitData.claimPayAmt}</div>
        </div>
        <div className="field-detail-container">
          <div className="sub-header-field-label">
            <span className="mdae-data-field-label">
              Patient Responsibility :{" "}
            </span>
          </div>
          <div className="mdae-data-field-content">
            {remitData.patientResponsibilityAmt}
          </div>
        </div>
        <div className="field-detail-container">
          <div className="sub-header-field-label">
            <span className="mdae-data-field-label">Outlier Payment : </span>
          </div>
          <div className="mdae-data-field-content">
            {remitData.miaClaimPPSOperatingOutlierAmt}
          </div>
        </div>
      </div>
    </div>
    <div style={{ marginTop: "15px" }}>
      <div style={{ marginBottom: "10px" }} className="mdae-data-field-label">
        Adjustments :
      </div>
      <MdaeDataGrid {...claimLevelAdjustmentDataGridOptions}></MdaeDataGrid>
    </div>
    <div style={{ marginTop: "20px" }}>
      <div style={{ marginBottom: "10px" }} className="mdae-data-field-label">
        Remarks :
      </div>
      <MdaeDataGrid {...claimLevelRemarksDataGridOptions}></MdaeDataGrid>
    </div>
    <div style={{ marginTop: "20px" }} className="mdae-data-field-label">
      <div> Adjustments : </div>
      <div style={{ overflow: 'hidden' }}>
        <MdaeDataGrid
          {...lineLevelAdjustmentDataGridOptions}
          mdaeDataGridCustomButtons={renderAdjustmentsGridToolbarButtonTemplate}
          onSelectionChanged={onSelectionChanged}
          selectedRowKeys={
            isVisibleFromImportCharges
              ? getSelectedRowKeys()
              : remitFieldsData.selectedKeys
          }
          keyExpr="casePayLineId"
          onRowPrepared={(e) => {
            if (e.rowType === "data" && e.data?.state === "Billed") {
              e.rowElement.classList.add("no-select-checkbox");
            }
          }}
        >
          {(!isEmpty(selectedSelectionListProperty) ||
            isVisibleFromImportCharges) && (
            <Selection
              mode="multiple"
              showCheckBoxesMode="always"
              allowSelectAll={false}
              deferred={false}
            />
          )}
          <MasterDetail
            enabled={true}
            component={LineLevelAdjustmentDetail}
          ></MasterDetail>
        </MdaeDataGrid>
      </div>
      {((!isEmpty(selectedSelectionListProperty) &&
        remitData?.linelevelAdjustmentList?.length > 0) ||
        (isVisibleFromImportCharges &&
          (remitData?.linelevelAdjustmentList?.length > 0 || remitData?.drg))) && (
        <div className="adjustment-buttons">
          <MdaeButton
            id={"pnlCancelRemitFieldsSecondaryBtn"}
            role={"secondary"}
            onClick={() => {
              dispatch({
                type: TOGGLE_REMIT_DETAIL_POPUP,
                data: { isRemitDetailPopupVisible: false },
              });
              dispatch({
                type: SET_REMIT_DETAIL_DATA,
                data: {
                  selectedKeys: [],
                  totalAmount: 0,
                },
              });
            }}
          >
            Cancel
          </MdaeButton>

          <MdaeButton
            id="pnlApplyRemitFieldsPrimaryBtn"
            role="primary"
            onClick={() => {
              if (isVisibleFromImportCharges) {
                // Find current roundCharges for the current round and current caseDetailId
                let roundCharges = [];
                if (caseDetailData?.roundData) {
                  const currentRound = caseDetailData.roundData.find(
                    (round) =>
                      round.eaRoundCaseId ===
                      currentImportRoundData.eaRoundCaseId
                  );
                  roundCharges = currentRound
                    ? currentRound.roundCharges || []
                    : [];
                }
                // Filter roundCharges for current caseDetailId and type REMIT
                const currentCaseDetailCharges = roundCharges.filter(
                  (charge) =>
                    charge.billingCaseDetailId === caseDetailId &&
                    charge.claimRemitType === "REMIT"
                );
                // Find if any of these charges are NOT present in selectedCodes (i.e., were unselected/removed)
                const removedCharges = currentCaseDetailCharges.filter(
                  (charge) =>
                    !selectedCodes.some(
                      (code) =>
                        code.targetType === charge.roundTargetType &&
                        code.codeValue === charge.roundTargetValue &&
                        code.caseDetailId === charge.billingCaseDetailId &&
                        code.targetId === charge.targetId
                    )
                );
                if (removedCharges.length > 0) {
                  showConfirmationPopup();
                } else {
                  handleApplyRemitFields();
                }
              } else {
                handleApplyRemitFields();
              }
            }}
            disabled={isVisibleFromImportCharges === true ? false : remitFieldsData?.selectedKeys?.length === 0}
          >
            Apply
          </MdaeButton>
        </div>
      )}
    </div>
  </div>
);
}

const getHeight = (list) => {
    if (list != undefined) {
      if (list?.length > 0) {
        return "auto";
      } else {
        return "50px";
      }
    } else {
      return "50px";
    }
  };

const getClaimLevelAdjustmentDataGridOptions = (remitData) => {
    const claimLevelAdjusmentList = remitData?.claimLevelAdjusmentList;
    const claimLevelAdjustmentDataGridOption: IMdaeDataGridProps = {
        id: "grdclaimLevelAdjustment",
        allowColumnResizing: true,
        height: getHeight(claimLevelAdjusmentList),
        pager:{
            showInfo:false
        },
        mdaeColumns: [{
            dataField: 'adjustReason',
            caption: 'Adjust Reason',
            dataType: 'string',
            width: 150,
        }, {
            dataField: 'units',
            caption: 'Units',
            dataType: 'string',
            width: 50,
        }, {
            dataField: 'amount',
            caption: 'Amount',
            dataType: 'string',
            width: 150,
            alignment: 'right',
        }, {
            dataField: 'description',
            caption: 'Description',
            dataType: 'string',
            width: 550
        },
        ],
        mdaeDataUpdaterConfig: [
            {
              actionType: GET_REMIT_DETAIL,
              isAsyncComplete: true,
              reducerName: "remitDetailReducer",
              widgetOptionBindings: {
                dataSource: "claimLevelAdjusmentList"
              },
            },
          ],
    };
    return claimLevelAdjustmentDataGridOption;
}


const getClaimLevelRemarksDataGridOptions = (remitData) => {
    const claimLevelRemarksCodeList = remitData?.claimLevelRemarksCodeList;
    const claimLevelRemarksDataGridOption: IMdaeDataGridProps = {
    id: "grdclaimLevelRemarks",
    allowColumnResizing: true,
    height: getHeight(claimLevelRemarksCodeList),
    pager:{
        showInfo:false
    },
    mdaeColumns: [
        {
            dataField: 'remarksCode',
            caption: 'Code',
            dataType: 'string',
            width: 50,
        },
        {
            dataField: 'description',
            caption: 'Description',
            dataType: 'string',
            width: 550,
        }],
        mdaeDataUpdaterConfig: [
            {
              actionType: GET_REMIT_DETAIL,
              isAsyncComplete: true,
              reducerName: "remitDetailReducer",
              widgetOptionBindings: {
                dataSource: "claimLevelRemarksCodeList"
              },
            },
          ],
    }
    return claimLevelRemarksDataGridOption;
}

const getLineLevelAdjustmentDataGridOptions = (
    onLineLevelAdjustmentDataGridInitialized,
    onLineLevelAdjustmentGridCellPrepared,
    remitData,
    onLineLevelAdjustmentGridCellClick
) => {
   let baseColumns = [
     {
       dataField: "state",
       caption: "State",
       dataType: "string",
       width: 130,
     },
     {
       dataField: "pos",
       caption: "Pos",
       dataType: "string",
       width: 50,
     },
     {
       dataField: "revCode",
       caption: "Rev Code",
       dataType: "string",
       width: 80,
     },
     {
       dataField: "hcpcs",
       caption: "HCPCS",
       dataType: "string",
       width: 360,
     },
     {
       dataField: "modifiers",
       caption: "Modifiers",
       dataType: "string",
       width: 100,
     },
     {
       dataField: "dateString",
       caption: "Date",
       dataType: "date",
       width: 100,
     },
     {
       dataField: "units",
       caption: "Units",
       dataType: "string",
       width: 90,
       alignment: "center",
     },
     {
       dataField: "totalCharges",
       caption: "Total Charges",
       dataType: "string",
       width: 120,
       alignment: "right",
     },
     {
       dataField: "providerPayment",
       caption: "Provider Payment",
       dataType: "string",
       alignment: "right",
       width: 120,
     },
   ];

   const linelevelAdjustmentList = remitData?.linelevelAdjustmentList;
    const lineLevelAdjustmentDataGridOption: IMdaeDataGridProps = {
      id: "grdLineLevelAdjustment",
      allowColumnResizing: true,
      height: getHeight(linelevelAdjustmentList),
      onInitialized: onLineLevelAdjustmentDataGridInitialized,
      onCellPrepared: onLineLevelAdjustmentGridCellPrepared,
      onCellClick: onLineLevelAdjustmentGridCellClick,
      dataSource:linelevelAdjustmentList,
      mdaeColumns: baseColumns,
      mdaeDataUpdaterConfig: [
        {
          actionType: GET_REMIT_DETAIL,
          isAsyncComplete: true,
          reducerName: "remitDetailReducer",
          widgetOptionBindings: {
            dataSource: "linelevelAdjustmentList",
          },
        },
      ],
    };
    return lineLevelAdjustmentDataGridOption;
}

const getLineLevelAdjustReasonDataGridOptions = (lineLevelAdjustReasonList) => {
    const lineLevelAdjustReasonDataGridOption : IMdaeDataGridProps =
    {
    id: "grdLineLevelAdjustReason",
    allowColumnResizing: true,
    height: getHeight(lineLevelAdjustReasonList),
    dataSource: lineLevelAdjustReasonList,
    pager:{
        showInfo:false
    },
    mdaeColumns : [
    {
        dataField : 'adjustReason',
        caption : 'Adjust Reason',
        dataType : 'string',
        width: 120
     },{
        dataField :'unit',
        caption : 'Units',
        dataType : 'number',
        width: 90
     },{
        dataField : 'amount',
        caption : 'Amount',
        dataType : 'string',
        alignment: 'left',
        width: 220
     },{
        dataField : 'description',
        caption : 'Description',
        width: 620,
        dataType : 'string'
     }],
    }
    return lineLevelAdjustReasonDataGridOption;
}

const getLineLevelRemarksCodeDataGridOptions = (lineLevelRemarksCodeList) => {
    const lineLevelRemarksCodeDataGridOption: IMdaeDataGridProps = {
    id: "grdLineLevelRemarksCode",
    allowColumnResizing: true,
    height: getHeight(lineLevelRemarksCodeList),
    dataSource: lineLevelRemarksCodeList,
    pager:{
        showInfo:false
    },
    mdaeColumns : [{
        dataField : 'remarksCode',
        caption : 'Remark Code',
        dataType : 'string',
        width: 120
     },{
        dataField : 'description',
        caption : 'Description',
        width: 620,
        dataType : 'string'
     }],
    }
    return lineLevelRemarksCodeDataGridOption;
}


export default RemitFields;